/* ============================================================
   MODA Furnitures — Product Page JS v4
   Custom button-based variant selector (no radio inputs)
   ============================================================ */
(function () {
  'use strict';

  const WEEKS = 156;

  function formatNZD(amount) {
    return '$' + Math.round(amount).toLocaleString('en-NZ');
  }
  function formatMoney(cents) {
    return '$' + (cents / 100).toLocaleString('en-NZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* ── UPDATE WEEKLY FINANCE (long-term box only) ── */
  function updateBNPL(priceDollars) {
    /* Weekly finance — 156 weeks = 36 months */
    const weeklyEl = document.querySelector('[data-weekly-price]');
    if (weeklyEl) weeklyEl.textContent = formatNZD(priceDollars / WEEKS);
  }

  /* ── GALLERY ── */
  function initGallery() {
    const slides = document.querySelectorAll('.moda-pdp__gallery-slide');
    const thumbs = document.querySelectorAll('.moda-pdp__thumb');
    if (!slides.length) return;
    function goTo(i) {
      slides.forEach((s, n) => s.classList.toggle('is-active', n === i));
      thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
    }
    thumbs.forEach(t => t.addEventListener('click', function () { goTo(+this.dataset.index); }));
    let sx = 0;
    const main = document.querySelector('.moda-pdp__gallery-main');
    if (main) {
      main.addEventListener('touchstart', e => { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', e => {
        const d = sx - e.changedTouches[0].clientX;
        if (Math.abs(d) < 40) return;
        const cur = [...slides].findIndex(s => s.classList.contains('is-active'));
        goTo(d > 0 ? Math.min(cur + 1, slides.length - 1) : Math.max(cur - 1, 0));
      }, { passive: true });
    }
  }

  /* ── VARIANTS (button-based, no radio) ── */
  function initVariants() {
    const form = document.getElementById('moda-add-form');
    if (!form) return;
    const productData = window.__moda_product_data;
    if (!productData) return;

    /* Build variant map keyed by joined options */
    const variantMap = {};
    productData.variants.forEach(v => { variantMap[v.options.join('|')] = v; });

    /* Track current selections per option index */
    const selected = {};
    productData.options.forEach((_, i) => {
      const firstBtn = form.querySelector(`.moda-opt__btn[data-option-index="${i}"].is-selected`)
                    || form.querySelector(`.moda-opt__btn[data-option-index="${i}"]`);
      if (firstBtn) selected[i] = firstBtn.dataset.optionValue;
    });

    function getVariant() {
      const key = Object.keys(selected).sort().map(k => selected[k]).join('|');
      return variantMap[key] || null;
    }

    function applyVariant(variant) {
      if (!variant) return;

      /* Update hidden id */
      const idInput = form.querySelector('#moda-variant-id');
      if (idInput) idInput.value = variant.id;

      /* Price */
      const priceDollars = variant.price / 100;
      const priceEl = document.querySelector('.moda-pdp__price-now');
      const wasEl   = document.querySelector('.moda-pdp__price-was');
      const saveEl  = document.querySelector('.moda-pdp__price-save');
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (wasEl) {
        const hasDiscount = variant.compare_at_price > variant.price;
        wasEl.style.display  = hasDiscount ? '' : 'none';
        if (hasDiscount) wasEl.textContent = formatMoney(variant.compare_at_price);
      }
      if (saveEl) {
        const hasDiscount = variant.compare_at_price > variant.price;
        saveEl.style.display = hasDiscount ? '' : 'none';
        if (hasDiscount) saveEl.textContent = 'Save ' + formatMoney(variant.compare_at_price - variant.price);
      }

      /* BNPL */
      updateBNPL(priceDollars);

      /* Stock */
      const stockEl = document.getElementById('moda-stock');
      if (stockEl) {
        stockEl.innerHTML = variant.available
          ? '<span class="moda-pdp__stock-dot"></span> In stock &nbsp;·&nbsp; NZ-wide delivery 1–2 weeks'
          : '<span class="moda-pdp__stock-dot moda-pdp__stock-dot--out"></span> Currently out of stock';
      }

      /* ATC */
      const atcBtn    = document.getElementById('moda-atc-btn');
      const stickyAtc = document.querySelector('.moda-sticky__atc');
      [atcBtn, stickyAtc].forEach(btn => {
        if (!btn) return;
        btn.disabled     = !variant.available;
        btn.textContent  = variant.available ? 'Add to cart' : 'Out of stock';
        btn.classList.toggle('moda-pdp__atc--oos',   !variant.available);
        btn.classList.toggle('moda-sticky__atc--oos', !variant.available);
      });
    }

    /* Wire up buttons */
    form.querySelectorAll('.moda-opt__btn').forEach(btn => {
      btn.addEventListener('click', function () {
        const idx = +this.dataset.optionIndex;
        selected[idx] = this.dataset.optionValue;

        /* Update active state in this group */
        form.querySelectorAll(`.moda-opt__btn[data-option-index="${idx}"]`).forEach(b => {
          b.classList.toggle('is-selected', b === this);
          b.setAttribute('aria-pressed', b === this ? 'true' : 'false');
        });

        /* Update option label */
        const label = document.getElementById('moda-opt-val-' + (idx + 1));
        if (label) label.textContent = this.dataset.optionValue;

        applyVariant(getVariant());
      });
    });

    /* Init payment displays with first variant */
    applyVariant(getVariant());
  }

  /* ── STICKY BAR ── */
  function initSticky() {
    const sticky = document.getElementById('moda-sticky');
    const atcBtn = document.getElementById('moda-atc-btn');
    if (!sticky || !atcBtn) return;
    new IntersectionObserver(entries => {
      const vis = entries[0].isIntersecting;
      sticky.classList.toggle('is-visible', !vis);
      sticky.setAttribute('aria-hidden', String(vis));
    }, { threshold: 0 }).observe(atcBtn);
  }

  /* ── HOOK INTO KALLES SWATCH CLICKS FOR PAYMENT UPDATES ── */
  function initKallesPaymentSync() {
    /* Initial load — get price from DOM */
    function getPriceFromDOM() {
      const el = document.querySelector('.t4s-price-item--sale .money, .t4s-price-item--regular .money, [data-product-price]');
      if (!el) return null;
      const txt = el.textContent.replace(/[^0-9.]/g, '');
      const dollars = parseFloat(txt);
      return isNaN(dollars) ? null : dollars;
    }

    /* Update on page load */
    function initPriceDisplay() {
      const price = getPriceFromDOM();
      if (price) updateBNPL(price);
    }

    /* Watch for Kalles price DOM changes (fires on variant switch) */
    const priceArea = document.querySelector('.t4s-product-price, .t4s-pr-price, [class*="product-price"]');
    if (priceArea && 'MutationObserver' in window) {
      const obs = new MutationObserver(function() {
        setTimeout(function() {
          const price = getPriceFromDOM();
          if (price) updateBNPL(price);
        }, 100);
      });
      obs.observe(priceArea, { childList: true, subtree: true, characterData: true });
    }

    /* Also listen for swatch item clicks directly */
    document.addEventListener('click', function(e) {
      const item = e.target.closest('.t4s-swatch__item');
      if (!item) return;
      setTimeout(function() {
        const price = getPriceFromDOM();
        if (price) updateBNPL(price);
      }, 200);
    });

    initPriceDisplay();
    /* Re-check after Kalles JS settles */
    setTimeout(initPriceDisplay, 800);
    setTimeout(initPriceDisplay, 1500);
  }

  /* ── INIT ── */
  function init() {
    initGallery();
    initVariants();
    initKallesPaymentSync();
    initSticky();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();